<template>
  <div class="panel-item" :class="{'is-selected': isSelected, 'has-children': hasChildren, 'has-path': hasPath}" :title="titleAttribute">
    <small-text v-if="path">{{ path }}</small-text>
    <span ref="name"><slot></slot></span>
    <svg-icon class="panel-item__arrow" v-if="hasChildren" :icon="arrow" :width="8" :height="13"></svg-icon>
  </div>
</template>

<script>
  import arrow from '@/assets/svg/arrow.svg'
  import SvgIcon from '@/components/common/svgIcon'
  import SmallText from './SmallText.vue'

  export default {
    components: {
      SvgIcon,
      SmallText
    },
    props: {
      name: String,
      path: {
        type: String
      },
      hasChildren: {
        type: Boolean,
        default: false
      },
      isSelected: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        arrow: Object.freeze(arrow),
        shouldDisplayTitleTooltip: false
      }
    },
    computed: {
      titleAttribute () {
        return this.shouldDisplayTitleTooltip ? this.name : null
      },
      hasPath () {
        return !!this.path
      }
    },
    mounted () {
      const nameEl = this.$refs.name
      this.shouldDisplayTitleTooltip = nameEl.scrollWidth > nameEl.offsetWidth
    }
  }
</script>

<style lang="scss">
  .panel-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: rem(10);
    border-left: 2px solid transparent;
    color: white;
    cursor: pointer;
    font-size: rem(16);
    list-style: none;
    text-align: left;

    span {
      min-width: 0;
      flex: 1 1 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      pointer-events: none;
    }

    &:hover,
    &.is-selected {
      border-left-color: color(yellow);
      background-color: #3D4B5A;

      .panel-item__arrow {
        fill: color(yellow);
      }
    }

    &.has-path {
      flex-direction: column;
      align-items: left;

      span {
        overflow: visible;
        text-overflow: ellipsis;
        white-space: pre-wrap;
        pointer-events: none;
      }
    }

    &__arrow {
      width: rem(8) !important;
      height: rem(13) !important;
      margin-left: auto;
      padding-left: rem(10);
      flex-shrink: 0;
      fill: currentColor;
    }
  }
</style>



// WEBPACK FOOTER //
// PanelItem.vue?da53f218